function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_11384_3569)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8.00098C0 3.58312 3.58214 0.000976562 8 0.000976562C12.4179 0.000976562 16 3.58312 16 8.00098C16 12.4188 12.4179 16.001 8 16.001C3.58214 16.001 0 12.4188 0 8.00098ZM1.35714 8.00098C1.35714 11.6688 4.33214 14.6438 8 14.6438C11.6679 14.6438 14.6429 11.6688 14.6429 8.00098C14.6429 4.33312 11.6679 1.35812 8 1.35812C4.33214 1.35812 1.35714 4.33312 1.35714 8.00098ZM7.39364 11.7499C7.23289 11.5892 7.14259 11.3712 7.14259 11.1438C7.14259 10.9165 7.23289 10.6985 7.39364 10.5377C7.55438 10.377 7.7724 10.2867 7.99973 10.2867C8.22706 10.2867 8.44508 10.377 8.60582 10.5377C8.76657 10.6985 8.85687 10.9165 8.85687 11.1438C8.85687 11.3712 8.76657 11.5892 8.60582 11.7499C8.44508 11.9107 8.22706 12.001 7.99973 12.001C7.7724 12.001 7.55438 11.9107 7.39364 11.7499ZM8.4283 9.14383H7.57116C7.49259 9.14383 7.4283 9.07955 7.4283 9.00098V4.14383C7.4283 4.06526 7.49259 4.00098 7.57116 4.00098H8.4283C8.50687 4.00098 8.57116 4.06526 8.57116 4.14383V9.00098C8.57116 9.07955 8.50687 9.14383 8.4283 9.14383Z",
  fill: "#F3BB1C"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11384_3569"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgWarningAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAccess);
export default __webpack_public_path__ + "static/media/warningAccess.971d9588.svg";
export { ForwardRef as ReactComponent };